import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Alert, Button, Card, DatePicker, Form, Input, Select, Space } from "antd"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { createCode, getBusinessClients } from "../../store/slices/codeSlice";
import { invoiceStatusChange } from "../../store/slices/jobSlice";

const EditInvouce = () => {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    useEffect(() => {
        dispatch(getBusinessClients())
    }, [dispatch])
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const data = {
                id,
                job_step: values?.job_step
            }
            const resultAction = await dispatch(invoiceStatusChange(data))
            if (invoiceStatusChange.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Invoice status updated successfully');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('')
                    navigate('/invoice')
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error update invoice status');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error update invoice status');
            setAlertType('error');
        } finally {
            setLoading(false);
        }
    }
    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Invoice</h1>
            <Card title="Edit Invoice" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Status"
                        name="job_step"
                        rules={[{ required: true, message: 'Please select status' }]}
                    >
                        <Select
                            placeholder="Select status"
                            options={[
                                { value: '', disabled : true, label: <span>Select status</span> },
                                { value: 'send invoice', label: <span>Send Invoice</span> },
                                { value: 'mark as task complete', label: <span>Mark as task complete</span> },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default EditInvouce